import Comp from "./ResultItem";

export default Comp;
